
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_VIEW_AUDIO(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.BOTVIEW, name: name, contents: [] };
  cat.contents = [
    BH.label("Bot-Ansichten -> " + name),
    BH.action("AUDIO_initialMute",
      `Mikrofon des Nutzers initial stummschalten.`,
      `RAGAI.EVENTS.listenTo("RAGAI.AUDIO.SPEECH.micconnected", function () {
  RAGAI.AUDIO.muteMic();
});`
    ),
    BH.action("AUDIO_MIC_SETTING", "Mikrofon des Nutzers {{option:dropdown=stummschalten|muteMic, aktivieren|unmuteMic}}", "await RAGAI.AUDIO.{{option}}();"),
    BH.withNested(
      BH.ragAi("AUDIO_doNotInterrupt",
        `⏭️ Automatisches Stummen des Mikrofons, um den Bot nicht zu unterbrechen.
Hinweistext, wenn der Bot...
...zuhört: {{botListening}}
...denkt: {{botThinking}}
...spricht: {{botSpeaking}}`,

        `RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"] = RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"] || [];
RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AUDIO.SPEECH.attRequest", function() {
  RAGAI.AUDIO.muteMic();
  RAGAI.AUDIO.setText({{botThinking}});
}));
RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AUDIO.SPEECH.attRecive", async function() {
  RAGAI.AUDIO.muteMic();
}));
RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AUDIO.SPEECH.play", async function() {
  RAGAI.AUDIO.muteMic();
  RAGAI.AUDIO.setText({{botSpeaking}});
}));
RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AUDIO.SPEECH.done", function() {
  RAGAI.AUDIO.unmuteMic();
  RAGAI.AUDIO.setText({{botListening}});
}));
RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AUDIO.botSayLoadComplete", function() {
  RAGAI.AUDIO.muteMic();
  RAGAI.AUDIO.setText({{botSpeaking}});
}));
RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"].push(RAGAI.EVENTS.listenTo("RAGAI.AUDIO.botSayEnded", function() {
  RAGAI.AUDIO.unmuteMic();
  RAGAI.AUDIO.setText({{botListening}});
}));`,),
      [
        { forValue: "botListening", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Jetzt reden" } },
        { forValue: "botThinking", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Nachricht wird gesendet" } },
        { forValue: "botSpeaking", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Jetzt zuhören" } }
      ]
    ),
    BH.ragAi("AUDIO_doNotInterruptCancel",
      "🧹 Automatisches Stummschalten verwerfen",
      `RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"] = RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"] || [];
for (const __id of RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"]) {
  RAGAI.EVENTS.off(__id);
}
RAGAI.VARIABLES["AUDIO_doNotInterrupt_ids"] = [];`,
    )];
  return cat;


}
